import React from "react";
import lanePlay from "./images/3_university/laneplay.png";
import mapping from "./images/3_university/mapping.png";
import mental from "./images/3_university/mental.png";
import physics from "./images/3_university/physics.png";
import universityPhone from "./images/3_university/university_phone.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Topic = ({ image, label }) => (
  <div
    style={{
      display: "flex",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      width: "50%",
      margin: 17,
    }}
  >
    <img
      style={{ display: "flex", flex: 1, marginRight: 17, maxWidth: "25%" }}
      src={image}
      alt={label}
    />
    <div
      style={{
        display: "flex",
        flex: 1,
        fontFamily: "OswaldBoldItalic",
        fontSize: TEXT_FONT_SIZE,
      }}
    >
      {label}
    </div>
  </div>
);

const Academy = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        color: "black",
        paddingLeft: 10,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "black",
          paddingLeft: 10,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "center",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
          }}
        >
          THE UNIVERSITY OF BOWLING
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            textAlign: "center",
            marginBottom: 30,
            maxWidth: "80%",
            fontSize: TEXT_FONT_SIZE,
          }}
        >
          With Storm University you can learn from our team at your own pace!
          We’ve added lessons on several important aspects of the game, such as
          mental game, ball mapping, physics and more. You can access the
          information you wish to learn on-demand.
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", flex: 1 }}>
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              style={{ maxWidth: "90%" }}
              src={universityPhone}
              alt={"University phone"}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            color: "black",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              fontFamily: "OswaldBoldItalic",
              flex: 1,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontFamily: "OswaldBoldItalic",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                marginTop: -17,
              }}
            >
              <Topic image={lanePlay} label={"Lane Play"} />
              <Topic image={mapping} label={"Ball Mapping"} />
              <Topic image={physics} label={"Ball Physix"} />
              <Topic image={mental} label={"Mental Game"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Academy;
